import { SyncTeamSubscriptionFnReq, SyncTeamSubscriptionFnRes } from '@uploadcam/common';
import { Functions, httpsCallable } from 'firebase/functions';

export type SyncTeamSubscriptionResult = SyncTeamSubscriptionFnRes;

export class SyncTeamSubscriptionInteractor {
  private readonly syncTeamSubscriptionFn = httpsCallable<
    SyncTeamSubscriptionFnReq,
    SyncTeamSubscriptionFnRes
  >(this.functions, 'syncTeamSubscription');

  constructor(private readonly functions: Functions) {}

  public async execute(): Promise<void> {
    await this.syncTeamSubscriptionFn({});
  }
}
